import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import AccessibilityMarkdown from "docs/accessibility.mdx"

export const getStaticProps = StaticPropsFactory("accessibility")

export default function Accessibility({ seo }: StaticPropsFactoryProps) {
  return (
    <>
      <SeoMetaData data={seo} />
      <AccessibilityMarkdown />
    </>
  )
}
